import Editor from ".";
import { HE, Property } from "../types";
import { Coloris } from "../vendor";
import EventEmitter from "./eventEmitter";

class StyleManager {
  private properties: Property[] = [];
  private sectors: HE[] | NodeList = [];
  private styles: Record<string, Record<string, string>> = {};
  private colorProperties: string[] = [
    "color",
    "background-color",
    "border-color",
  ];
  private openedColorSector: HE | null = null;

  constructor(
    private containerElem: HE,
    private ee: EventEmitter,
    private editor: Editor
  ) {}

  init() {
    Coloris.init();
    this.initSectorHandlders();
  }

  addProperty(property: Property) {
    this.properties.push(property);
  }

  show() {
    const selectedEl = this.editor.getSelectedEl() as HE;
    const styles = this.styles[selectedEl.id] || {};
    this.loadElementStyles(styles);
    this.containerElem.classList.add("show");
  }

  hide() {
    this.containerElem.classList.remove("show");
  }

  initSectorHandlders() {
    const sectors: NodeList =
      this.containerElem.querySelectorAll("input, select");
    this.sectors = sectors;

    sectors.forEach((sector) => {
      sector.addEventListener("change", (e: Event) => {
        this.handleSectorChange(e.target as HE);
      });

      // @ts-ignore
      const property = sector.getAttribute("name") as string;

      if (this.colorProperties.includes(property)) {
        sector.addEventListener("open", () => {
          this.openedColorSector = sector as HE;
        });

        sector.addEventListener("close", () => {
          this.openedColorSector = null;
        });
      }
    });

    document.addEventListener("coloris:pick", () => {
      if (this.openedColorSector) {
        this.handleSectorChange(this.openedColorSector);
      }
    });
  }

  handleSectorChange(sector: HE) {
    const selectedEl = this.editor.getSelectedEl() as HE;
    const property = sector.getAttribute("name") as string;
    // @ts-ignore
    const value = sector.value as string;

    if (this.styles[selectedEl.id] === undefined) {
      this.styles[selectedEl.id] = {
        [property]: value,
      };
    } else {
      this.styles[selectedEl.id][property] = value;
    }

    // @ts-ignore
    selectedEl.style[property] = value;
    this.editor.showToolbar();
  }

  loadElementStyles(styles: Record<string, string>) {
    this.sectors.forEach((sector: any) => {
      const property = sector.getAttribute("name") as string;

      let value = styles[property];

      if (value) {
        sector.value = value;
      } else {
        sector.value = sector.getAttribute("defaultValue") || "";
      }

      if (this.colorProperties.includes(property)) {
        sector.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  }

  getStylesById(id: string) {
    return this.styles[id];
  }
}

export default StyleManager;
